import { render, staticRenderFns } from "./previewImgs.vue?vue&type=template&id=63791fd4"
import script from "./previewImgs.vue?vue&type=script&lang=js"
export * from "./previewImgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-prod-env-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63791fd4')) {
      api.createRecord('63791fd4', component.options)
    } else {
      api.reload('63791fd4', component.options)
    }
    module.hot.accept("./previewImgs.vue?vue&type=template&id=63791fd4", function () {
      api.rerender('63791fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/previewImg/previewImgs.vue"
export default component.exports